import React from 'react';
import PropTypes from 'prop-types';
import {Button, Form} from 'react-bootstrap';
import {FaCalendarAlt, FaChevronLeft, FaChevronRight} from 'react-icons/fa';
import {Views} from 'react-big-calendar';
import {useTranslation} from 'react-i18next';

const SkyworkPlannerToolbar = ({
  label,
  view,
  onNavigate,
  onView,
  fields,
  selectedFieldId,
  onFieldChange,
  allFieldsLabel,
  todayLabel,
  dayLabel,
  weekLabel,
  previousLabel,
  nextLabel,
  chooseFieldLabel,
  weekDisabled
}) => {
  const {t} = useTranslation();
  const labels = {
    allFields: allFieldsLabel === undefined ? t('ALL_FIELDS') : allFieldsLabel,
    today: todayLabel || t('TODAY'),
    day: dayLabel || t('DAY'),
    week: weekLabel || t('WEEK'),
    previous: previousLabel || t('PREVIOUS'),
    next: nextLabel || t('NEXT'),
    chooseField: chooseFieldLabel || t('SELECT_FIELD')
  };

  return <div className="skywork-planner-toolbar">
    <Button className="skywork-planner-today" variant="outline-light" onClick={() => onNavigate('TODAY')}>
      {labels.today}
    </Button>
    <div className="skywork-planner-toolbar-navigation">
      <Button variant="outline-light" onClick={() => onNavigate('PREV')} aria-label={labels.previous}><FaChevronLeft/></Button>
      <div className="skywork-planner-toolbar-date">
        <FaCalendarAlt aria-hidden="true"/>
        <span>{label}</span>
      </div>
      <Button variant="outline-light" onClick={() => onNavigate('NEXT')} aria-label={labels.next}><FaChevronRight/></Button>
    </div>
    <div className="skywork-planner-toolbar-view" role="group">
      <Button className={view === Views.DAY ? 'active' : ''} variant="outline-light" onClick={() => onView(Views.DAY)}>{labels.day}</Button>
      <Button className={view === Views.WEEK ? 'active' : ''} variant="outline-light" disabled={weekDisabled} onClick={() => onView(Views.WEEK)}>{labels.week}</Button>
    </div>
    {fields.length > 0 && onFieldChange && (
      <Form.Control
        as="select"
        className="skywork-planner-toolbar-fields"
        aria-label={labels.chooseField}
        value={selectedFieldId || ''}
        onChange={event => onFieldChange(event.target.value)}
      >
        {labels.allFields !== null && <option value="">{labels.allFields}</option>}
        {fields.map(field => <option key={field.id} value={field.id}>{field.name}</option>)}
      </Form.Control>
    )}
  </div>;
};

SkyworkPlannerToolbar.propTypes = {
  label: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  fields: PropTypes.array,
  selectedFieldId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onFieldChange: PropTypes.func,
  allFieldsLabel: PropTypes.string,
  todayLabel: PropTypes.string,
  dayLabel: PropTypes.string,
  weekLabel: PropTypes.string,
  previousLabel: PropTypes.string,
  nextLabel: PropTypes.string,
  chooseFieldLabel: PropTypes.string,
  weekDisabled: PropTypes.bool
};

SkyworkPlannerToolbar.defaultProps = {
  fields: [],
  selectedFieldId: '',
  onFieldChange: null,
  allFieldsLabel: undefined,
  todayLabel: null,
  dayLabel: null,
  weekLabel: null,
  previousLabel: null,
  nextLabel: null,
  chooseFieldLabel: null,
  weekDisabled: false
};

export default SkyworkPlannerToolbar;
